'use strict';

var shadowRootContainer = document.querySelector('.klarna_osm');

/**
 * This hides the BNPL OSM container if the price exceeds the limit for BNPL.
 */
function refreshOSMContainer() {
    var klarnaContainer = document.querySelector('.klarna_container');
    if (!klarnaContainer) {
        return;
    }

    var shadowRoot = shadowRootContainer.shadowRoot;
    if (!shadowRoot) {
        return;
    }

    var afterpay = document.querySelector('.afterpay');
    if (!afterpay) {
        return;
    }

    var loaded = shadowRoot.querySelector('.loaded');

    if (loaded) {
        afterpay.classList.remove('d-none');
        afterpay.classList.add('d-flex');
    } else {
        afterpay.classList.add('d-none');
        afterpay.classList.remove('d-flex');
    }
}

/**
 * Mutation observer to look out for Klarna shadow DOM changes
 */
function observeShadowDOM() {
    var shadowRoot = shadowRootContainer ? shadowRootContainer.shadowRoot : undefined;

    if (shadowRoot) {
        var observer = new MutationObserver(() => {
            refreshOSMContainer();
        });

        observer.observe(shadowRoot, {
            childList: true,
            subtree: true
        });

        refreshOSMContainer();
    }
}

/**
 * This updates the purchase amount on the klarna widget and refreshes it
 * @param {Object} purchaseAmt - the price to update.
 */
function updateTotal(purchaseAmt) {
    var klarnaIsDefined = (typeof window.Klarna !== 'undefined' && typeof window.Klarna.OnsiteMessaging !== 'undefined');
    if (klarnaIsDefined && purchaseAmt && shadowRootContainer) {
        var newPurchaseAmount = purchaseAmt.replace(/[^0-9]+/g, '');
        var existingPurchaseAmount = shadowRootContainer.dataset ? shadowRootContainer.dataset.purchaseAmount : undefined;
        if (newPurchaseAmount !== existingPurchaseAmount) {
            shadowRootContainer.dataset.purchaseAmount = newPurchaseAmount;
            observeShadowDOM();
            window.Klarna.OnsiteMessaging.refresh();
        }
    }
}

/**
 * This updates initialises the Klarna OSM.
 */
function init() {
    var klarnaIsDefined = (typeof window.Klarna !== 'undefined' && typeof window.Klarna.OnsiteMessaging !== 'undefined');
    if (klarnaIsDefined && shadowRootContainer) {
        observeShadowDOM();
    }
}

module.exports = {
    updateTotal: updateTotal,
    init: init
};
